import tto from "../assets/resim_5.png";

const Tto = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>What does POLSAN Science and Technology Park Offer?</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>The Technology Transfer Office (TTO) carries out activities such as identifying new ideas and inventions in line with the needs of universities, industry, and stakeholders within the regional innovation ecosystem; assessing their commercialization potential; conducting research and application processes related to intellectual property rights; and providing information and guidance on these matters. In addition to these core activities, the following services are provided either directly by POLSAN S&T Park or through the Technology Transfer Office units of partner universities:</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12">
          <ul>
            <li>Delivering joint awareness-raising, promotion, information, and training services tailored to identified needs</li>
            <li>Conducting benchmarking activities based on areas of expertise and on-site examination of best practices</li>
            <li>Joint use, by mutual agreement, of conference rooms, meeting halls, and similar facilities owned by the TTO units of partner universities for programs conducted within the scope of joint activities</li>
            <li>Provision of network support and organization of events by the TTO units of partner universities, in line with requests received from their respective regions, to foster collaboration</li>
            <li>Submission of joint project applications</li>
            <li>Accessing the expert pools of the other party, subject to approval, when deemed necessary by the TTO units of partner universities</li>
            <li>Dissemination of announcements related to joint activities carried out within the scope of collaboration through the social media channels of the Parties throughout the protocol period</li>
            <li>Mutual exchange of views between the Parties on matters including university–industry collaboration, project activities, matchmaking, intellectual and industrial property rights, techno-entrepreneurship, and company formation (startup/spin-off)</li>
            <li>Joint organization of various events such as project markets, matchmaking events, exhibitions, fairs, and similar activities within the framework of university–industry collaboration and related protocols</li>
            <li>Provision of reciprocal access to resources (mentors, trainers, academic matchmaking, etc.), business networks, and the Park services aimed at fostering the development of techno-entrepreneurship</li>
          </ul>
        </div>
        {/* <div className="col-2 mt-4">
          <img src={tto} alt="TTO" className="img-fluid" />
        </div> */}
      </div>
    </>
  );
};

export default Tto;
